export { gbp } from "./investorOptions";

const opt = (arr) => arr.map((v) => ({ value: v, label: v }));

export const TX_TYPES = ["Expense", "Revenue", "Founder contribution", "Loan received", "Loan repayment", "Investment received", "Grant received", "Refund", "Transfer", "Other"];
export const TX_STATUS = ["Planned", "Committed", "Paid", "Received", "Cancelled"];
export const TX_OWNERS = opt(["Steven", "Richard", "Both", "Company", "External"]);
export const CATEGORIES = ["Founder salaries", "Freelancers", "Software", "Marketing", "Influencers", "Office", "Legal and professional", "App development", "Content production", "Travel and events", "Insurance", "Equipment", "Subscriptions", "Loan repayments", "Revenue", "Funding", "Other"];
export const RECURRENCE = ["None", "Weekly", "Monthly", "Quarterly", "Annually"];
export const YESNO = ["No", "Yes"];
export const BUDGET_PERIODS = ["Monthly", "Quarterly", "Annual", "Funding round", "Launch budget", "Custom"];
export const BUDGET_STATUS = ["Draft", "Active", "Closed", "Archived"];
export const FUNDING_TYPES = ["Founder contribution", "Director loan", "Personal loan introduced to company", "Commercial loan", "Angel investment", "Venture investment", "Grant", "Revenue", "Other"];
export const FUNDING_STATUS = ["Proposed", "Applied", "Approved", "Partially received", "Received", "Rejected", "Repaid", "Closed"];

export const asOpts = opt;

export const finBadge = (s) => ({
  Paid: "success", Received: "success", Active: "success", Repaid: "success", Approved: "info",
  Committed: "info", Applied: "info",
  Planned: "warning", "Partially received": "warning",
  Cancelled: "neutral", Draft: "neutral", Closed: "neutral", Archived: "neutral", Proposed: "neutral",
  Rejected: "error",
}[s] || "neutral");

export const gbp2 = (n) => new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0);

export const isInflow = (t) => ["Founder contribution", "Loan received", "Investment received", "Grant received", "Revenue", "Refund"].includes(t);
export const monthLabel = (m) => { try { const [y, mo] = m.split("-"); return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("en-GB", { month: "short", year: "numeric" }); } catch { return m; } };
